// import {
//   DEFAULT_BLACK_IMAGE_PATH,
// } from '../../../scripts/Routes/images.js';

// const cloudinaryPhotographyPath = 'https://res.cloudinary.com/dgrlg424p/image/upload/v1564266187/my-personal-website/photography/';

const cloudinaryPhotographyPathScaled = 'https://res.cloudinary.com/dgrlg424p/image/upload/c_scale,w_500/v1564266187/my-personal-website/photography/';

export const julyPhotography2019 = [
    {
        'src': cloudinaryPhotographyPathScaled + '2019/july/27/27_fi6qnh.jpg',
        'text': 'Chillin',
        'url': '#',
    },
];
